<template>
  <div class="content" style="overflow-y: auto">
    <!-- 左侧标签页 -->
    <div class="fl back-color-fff borderR6 left-tree-box">
      <!-- <el-input
        v-if="tabType == 1"
        placeholder="输入关键字进行过滤"
        v-model="filterText"
        class="tab-input"
      ></el-input> -->
      <el-input
        v-if="tabType == 1"
        size="mini"
        placeholder="输入关键字进行过滤"
        v-model="filterText"
        style="width: 80%; margin-top: 10px"
      >
      </el-input>
      <!-- class="tab-input" -->
      <el-input
        v-if="tabType == 2"
        size="mini"
        placeholder="输入标签名查询"
        v-model="pageTag.labelName"
        style="width: 80%; margin-top: 10px"
        @input="tagChange()"
      >
      </el-input>
      <!-- <div class="tab-plane">
        <div
          :class="tabType == 1 ? 'tab-list tab-active' : 'tab-list'"
          @click="tabChange(1)"
        >
          组织架构
        </div>
        <div
          :class="tabType == 2 ? 'tab-list tab-active' : 'tab-list'"
          @click="tabChange(2)"
        >
          标签
        </div>
      </div> -->
      <!-- 组织架构 -->
      <div class="block">
        <el-tree
          :data="superiorOrganization"
          ref="tree"
          class="mt10 mb10"
          :filter-node-method="filterNode"
          :props="defaultPropsOrganisation"
          @node-click="handleNodeCilck"
        >
          <span
            class="custom-tree-node"
            style="width: 100%"
            slot-scope="{ node, data }"
            @mouseenter="mouseenter(data)"
            @mouseleave="mouseleave(data)"
          >
            <span
              class="node-lable-sty"
              style="
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
              :title="node.label"
              >{{ node.label }}</span
            >
            <span style="position: absolute; right: 5px" v-show="data.show">
              <!-- <el-button
                  type="text"
                  size="mini"
                  @click="() => append(data)"
                  icon="el-icon-plus"
                >
                </el-button> -->
              <img
                class="tags-edit"
                @click="() => append(data)"
                src="../../assets/images/tab_edit.png"
                alt=""
              />
              <img
                class="tags-add"
                @click="() => addAppend(data)"
                src="../../assets/images/add.png"
                alt=""
              />
              <img
                class="tags-del"
                @click="() => remove(node, data)"
                src="../../assets/images/tab_delete.png"
                alt=""
              />
              <!-- <el-dropdown v-show="data.show">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="addFolder">新增文件夹</el-dropdown-item>
                  <el-dropdown-item command="edit">编辑</el-dropdown-item>
                  <el-dropdown-item command="delete">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </span>
            <span
              v-if="data.bizState !== 'Y'"
              style="
                flex-shrink: 0;
                display: inline-block;
                width: 48px;
                height: 21px;
                line-height: 21px;
                font-size: 12px;
                background: rgba(239, 239, 239, 0.38);
                border-radius: 11px;
                margin-left: 5px;
                color: #6e6e6e;
              "
              >无效</span
            >
          </span>
        </el-tree>
      </div>
      <!-- 标签 -->
      <!-- <div class="block" v-if="tabType == 2">
        <el-button
          icon="el-icon-plus"
          class="w100f mt10 mb15"
          @click="addTagsList()"
          >添加标签</el-button
        >
        <div
          :class="tagsIndex == index ? 'tags-list tags-active' : 'tags-list'"
          v-for="(item, index) in tagsList"
          :key="index"
          @click="tagsSelect(item, index)"
        >
          <div class="tags-list-left">
            <img
              class="tags-logo"
              src="../../assets/images/tab_tags.png"
              alt=""
            />
            <span> {{ item.labelName }}</span>
          </div>
          <div class="tags-list-right" v-if="tagsIndex == index">
            <img
              class="tags-edit"
              @click="addTagsList(item)"
              src="../../assets/images/tab_edit.png"
              alt=""
            /><img
              class="tags-del"
              @click="tagsDel(item.guid)"
              src="../../assets/images/tab_delete.png"
              alt=""
            />
          </div>
        </div>
        <div v-if="tagsList.length < 1" class="tags-list">暂无数据</div>
      </div> -->
    </div>
    <!-- 人员表格 -->
    <div v-if="tabType == 1" class="right-content-box">
      <div class="search-area">
        <p class="select-node">
          <span class="mr15 fontC-4fa1a4" v-show="$route.query.pageTitle">{{
            $route.query.pageTitle
          }}</span
          >{{ organisationName }}（{{ page.totalRows }}个人）
        </p>
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="search-area-div">账号</div>
            <el-input
              size="mini"
              v-model="page.logonUser"
              clearable
              class="ipt-sty"
              placeholder="请输入账号"
            ></el-input>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">姓名</div>
            <el-input
              size="mini"
              clearable
              v-model="page.staffName"
              class="ipt-sty"
              placeholder="请输入姓名"
            ></el-input>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">手机号</div>
            <el-input
              size="mini"
              clearable
              v-model="page.mobileNo"
              class="ipt-sty"
              placeholder="请输入手机号"
            ></el-input>
          </el-col>
          <el-col :span="6" class="search-btn-box">
            <el-button
              size="mini"
              type="text"
              @click="showMore = !showMore"
              :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            >
              {{ showMore ? "收起筛选" : "更多筛选" }}
            </el-button>
            <el-button size="mini" type="info" @click="getData(true)"
              >搜索</el-button
            >
            <el-button size="mini" type="danger" @click="empty">清空</el-button>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="mt15" v-show="showMore">
          <el-col :span="6">
            <div class="search-area-div">状态</div>
            <el-select
              size="mini"
              v-model="page.bizState"
              clearable
              placeholder="请选择"
              class="ipt-sty"
            >
              <el-option
                v-for="item in bizStateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <div class="radio-sty">
                  <el-radio v-model="page.bizState" label="Y">有效</el-radio>
                  <el-radio v-model="page.bizState" label="S">停用</el-radio>
            </div> -->
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">人员类型</div>
            <el-select
              size="mini"
              v-model="page.staffType"
              clearable
              placeholder="请选择"
              class="ipt-sty"
            >
              <el-option
                v-for="item in staffTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <div class="radio-sty">
                  <el-radio v-model="page.staffType" label="1" class="radio-ora">组内成员</el-radio>
                  <el-radio v-model="page.staffType" label="2" class="radio-ora">备案成员</el-radio>
            </div> -->
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">销售区域</div>
            <el-select
              size="mini"
              v-model="page.salesTerritoryGuids"
              clearable
              filterable
              multiple
              collapse-tags
              placeholder="请选择"
              class="ipt-sty"
            >
              <el-option
                v-for="sa in salesTerritoryList"
                :key="sa.guid"
                :label="sa.territoryName"
                :value="sa.guid"
              >
              </el-option>
            </el-select>
            <!-- <el-input
              size="mini"
              clearable
              v-model="page.salesTerritoryName"
              class="ipt-sty"
              placeholder="请输入"
            ></el-input> -->
          </el-col>
        </el-row>
      </div>
      <div
        class="back-color-fff content-main-box"
        :style="'height:' + contentMainHeight + 'px;'"
      >
        <div class="button-area">
          <el-button icon="el-icon-plus" size="mini" type="info" @click="add(1, '')" >新增人员</el-button>
          <el-button icon="el-icon-plus" size="mini" type="info" @click="batchExport" >批量导出</el-button>
          <el-button size="mini" @click="batchChangeState('Y')" >批量启用</el-button>
          <el-button size="mini" @click="batchChangeState('S')" >批量停用</el-button>
          
          <!-- <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> -->
          <!-- <div class="fr line-h40 h40 font-S16 mr16">{{tenantName}}，有<b class="fontC-4fa1a4"> {{page.totalRows}} </b>个人员</div> -->
          <!-- <el-button plain size="medium">历史数据</el-button> -->
        </div>
        <el-table
          :data="tableData"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          border
          :height="tableHeight"
          style="width: 100%"
          v-loading="loading"
          :row-key="(row) => row.guid"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="40"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="序号"
            width="60"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="logonUser"
            label="账号"
            width="150"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="姓名"
            width="150"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="jobNumber"
            label="工号"
            width="150"
            header-align="center"
            align="center"
          ></el-table-column> -->
          <el-table-column
            prop="mobileNo"
            label="手机号"
            width="150"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="salesTerritoryName"
            label="销售区域"
            width="150"
            header-align="center"
            align="center"
          >
          <template slot-scope="scope">
            
              <span>{{ scope.row.salesTerritoryName ||'-' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="staffType"
            label="人员类型"
            width="120"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.staffType == '1'"
                class="staff-type staff-inside"
                >组内成员</span
              >
              <span v-else class="staff-type staff-wrap">备案成员</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="organisationNames"
            label="组织"
            width="150"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.organisationNames | roleNames
            }}</template>
          </el-table-column>
          <el-table-column
            prop="positionNames"
            label="岗位"
            width="150"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.positionNames | roleNames
            }}</template>
          </el-table-column>
          <el-table-column
            prop="roleNames"
            label="角色"
            width="150"
            header-align="center"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{
              scope.row.roleNames | roleNames
            }}</template>
          </el-table-column>
          <el-table-column
            prop="bizState"
            label="状态"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.bizState == 'Y'"
                class="staff-type-biz staff-inside"
                >有效</span
              >
              <span v-else class="staff-type-biz staff-wrap">停用</span>
            </template>
            <!-- <template slot-scope="scope">{{ scope.row.bizState | getBizState }}</template> -->
          </el-table-column>
          <el-table-column
            prop="isActivity"
            label="活动类型"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.isActivity == "Y" ? "活动" : "非活动"
            }}</template>
          </el-table-column>
          <el-table-column
            prop="isTask"
            label="业务执行"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.isTask == "Y" ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column
            prop="isTeamLeader"
            label="团队领导"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.isTeamLeader == "Y" ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column
            prop=" dutyStatus;"
            label="在职状态"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.dutyStatus == "1"
                ? "在职"
                : !scope.row.dutyStatus
                ? "-"
                : "离职"
            }}</template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            width="150"
            sortable
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.createTime | getDate
            }}</template>
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="上次更新时间"
            width="150"
            sortable
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">{{
              scope.row.updateTime | getDate
            }}</template>
          </el-table-column>
          <el-table-column
            label="操作"
            header-align="center"
            width="250"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
              <a class="txt-color" @click="resetPwd(scope.row.userGuid)"
                >重置密码 |
              </a>
              <a
                class="txt-color"
                @click="resetOpenId(scope.row)"
                v-loading.fullscreen.lock="fullscreenLoading"
                >清除微信ID |
              </a>
              <a
                class="txt-color-red"
                @click="getDeleteData(2, scope.row.guid, scope.row.tenantGuid)"
                >删除</a
              >
            </template>
          </el-table-column>
        </el-table>
        
        <el-pagination
          class="pt pb back-color-fff"
          style="padding: 16px"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 选择组织人员表格 -->
    <div v-if="tabType == 2" class="right-content-box">
      <div class="search-area table-tags">
        <span class="person-tags tags-left font-S19"
          >{{ (tagsDetailData && tagsDetailData.labelName) || "标签信息" }}（{{
            tagsDetailData && tagsDetailData.staffCount
          }}人）</span
        >
        <span class="person-tags tags-right" @click="tagsDetail(1)"
          >查看标签详情</span
        >
      </div>
      <div
        class="back-color-fff content-main-box"
        :style="'height:' + contentMainHeight2 + 'px;'"
      >
        <div class="button-area">
          <el-button
            icon="el-icon-plus"
            size="mini"
            type="info"
            @click="addDepartment()"
            >新增部门/成员</el-button
          >
          <el-button size="mini" type="danger" @click="getDeleteDep()"
            >移出</el-button
          >
          <!-- <el-button plain size="medium">历史数据</el-button> -->
        </div>
        <el-table
          :data="tagsTable"
          @selection-change="handleSelectionChangeTag"
          border
          :height="tableHeight2"
          style="width: 100%"
          v-loading="loadingTagTable"
        >
          <el-table-column
            type="selection"
            width="40"
            header-align="left"
            align="left"
          ></el-table-column>
          <el-table-column
            label="序号"
            width="60"
            header-align="left"
            align="left"
          >
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            width="200"
            header-align="left"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="location"
            label="所在组织"
            header-align="left"
            align="left"
          >
            <!-- <template slot-scope="scope">{{ scope.row.organisationNames | roleNames }}</template> -->
          </el-table-column>
        </el-table>
        
        <el-pagination
          class="pt pb back-color-fff"
          style="padding: 16px"
          background
          @size-change="handleSizeChangeTagTable"
          @current-change="handleCurrentChangeTagTable"
          :page-sizes="[10, 100, 200]"
          :current-page="pageDepTable.pageIndex"
          :page-size="pageDepTable.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageDepTable.totalRows"
        >
        </el-pagination>
      </div>
    </div>
    <div style="clear: both"></div>

    <!-- 新增人员弹框 -->
    <el-dialog
      :title="textTitle"
      :visible.sync="dialogFormVisible"
      width="900px"
    >
      <el-row :gutter="10">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="110px"
          :label-position="right"
          class="demo-ruleForm"
        >
          <el-col :span="12">
            <el-form-item label="人员名称:" prop="staffName">
              <el-input
                v-model.trim="ruleForm.staffName"
                autocomplete="off"
                size="small"
                class="w100f"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="isAllocateNo">
            <el-form-item label="货位ID:" prop="allocateNo">
              <el-input
                v-model.trim="ruleForm.allocateNo"
                autocomplete="off"
                size="small"
                class="w100f"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!isAllocateNo">
            <el-form-item label="工号:" prop="jobNumber">
              <el-input
                v-model="ruleForm.jobNumber"
                autocomplete="off"
                size="small"
                class="w100f"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账号:" prop="logonUser">
              <el-input
                v-model.trim="ruleForm.logonUser"
                autocomplete="off"
                size="small"
                class="w100f"
                @input="getUser"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码:" v-if="pwdSh">
              <el-input
                v-model.trim="ruleForm.pwd"
                autocomplete="off"
                size="small"
                class="w100f"
                show-password
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号:" prop="mobileNo">
              <el-input
                v-model.trim="ruleForm.mobileNo"
                autocomplete="off"
                size="small"
                class="w100f"
                @blur="getInfoByMobileNo"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱:" prop="email">
              <el-input
                v-model="ruleForm.email"
                autocomplete="off"
                size="small"
                class="w100f"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="药企方名称:" prop="tenantName">
              <el-input
                placeholder="药企方名称"
                v-model="ruleForm.tenantName"
                autocomplete="off"
                size="small"
                class="w100f"
                :disabled="true"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="所属部门:" prop="organisationGuids">
              <el-input
                placeholder="请选择所属部门"
                v-model="selectText"
                autocomplete="off"
                size="small"
                class="w100f"
                @focus="setTableHead"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="角色:" prop="roleGuids">
              <span slot="label">
                <el-popover
                  placement="top-start"
                  content="可以使用其他人新建的角色，但是不可修改和删除"
                  trigger="hover"
                >
                  <i slot="reference" class="el-icon-question"></i>
                </el-popover>
                角色:
              </span>
              <el-cascader
                class="w100f"
                v-model="ruleForm.roleGuids"
                size="small"
                filterable
                :options="roleList"
                :show-all-levels="false"
                :props="cascaderProps"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="销售区域:">
              <el-select
                v-model="ruleForm.salesTerritoryGuid"
                placeholder="请选择"
                class="w100f"
                size="small"
                filterable
              >
                <el-option
                  v-for="sa in getSalesTerritoryList"
                  :key="sa.guid"
                  :label="sa.territoryName"
                  :value="sa.guid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="岗位:" prop="positionGuids">
              <el-select
                v-model="ruleForm.positionGuids"
                placeholder="请选择"
                filterable
                class="w100f"
                size="small"
              >
                <el-option
                  v-for="po in positionList"
                  :key="po.guid"
                  :label="po.positionName"
                  :value="po.guid"
                  v-if="po.bizState == 'Y'"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现住地址:">
              <!-- <citys @incre="incres" :size="'small'" :workareaList.sync="workareaList"></citys> -->
              <el-cascader
                filterable
                ref="cascaderFirst"
                :options="options"
                class="w100f"
                size="small"
                v-model="workareaList"
                :props="{ checkStrictly: false, value: 'label' }"
                @change="incres"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址:">
              <el-input
                v-model="ruleForm.address"
                autocomplete="off"
                size="small"
                class="w100f"
              ></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-form-item label="人员类型:" class="t-left">
              <el-radio v-model="ruleForm.staffType" label="1">组内成员</el-radio>
              <el-radio v-model="ruleForm.staffType" label="2">备案成员</el-radio>
            </el-form-item>
          </el-col> -->

          <el-col :span="12">
            <el-form-item label="性别:" class="t-left">
              <el-radio v-model="ruleForm.sex" label="M">男</el-radio>
              <el-radio v-model="ruleForm.sex" label="F">女</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="人员状态:" class="t-left">
              <el-radio v-model="ruleForm.bizState" label="Y">有效</el-radio>
              <el-radio v-model="ruleForm.bizState" label="S">无效</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="ruleForm.staffType == '2'">
            <el-form-item label="是否认证审核:" class="t-left">
              <el-radio v-model="ruleForm.isCertAudit" label="Y">是</el-radio>
              <el-radio v-model="ruleForm.isCertAudit" label="N">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item required label="活动类型:" class="t-left">
              <el-radio v-model="ruleForm.isActivity" label="Y">活动</el-radio>
              <el-radio v-model="ruleForm.isActivity" label="N"
                >非活动</el-radio
              >
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item required label="业务执行:" class="t-left">
              <el-radio v-model="ruleForm.isTask" label="Y">是</el-radio>
              <el-radio v-model="ruleForm.isTask" label="N">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item required label="团队领导:" class="t-left">
              <el-radio v-model="ruleForm.isTeamLeader" label="Y">是</el-radio>
              <el-radio v-model="ruleForm.isTeamLeader" label="N">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item required label="在职状态:" class="t-left">
              <el-radio v-model="ruleForm.dutyStatus" :disabled="true" label="1"
                >在职</el-radio
              >
              <el-radio v-model="ruleForm.dutyStatus" :disabled="true" label="3"
                >离职</el-radio
              >
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item required label="团队进度:" class="t-left">
              <el-radio v-model="ruleForm.isShowLeaderTaskPercent" label="Y"
                >移动端展示</el-radio
              >
              <el-radio v-model="ruleForm.isShowLeaderTaskPercent" label="N"
                >移动端不展示</el-radio
              >
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item required class="t-left">
              <span style="width: 200px" slot="label"
                >是否管理员<el-tooltip
                  class="item"
                  effect="dark"
                  content="母账号可见公司所有基础资料，包括产品、客户、订单。"
                  placement="right-start"
                  ><i class="el-icon-question"></i></el-tooltip
              ></span>
              <el-radio v-model="ruleForm.isAdmin" label="1">是</el-radio>
              <el-radio v-model="ruleForm.isAdmin" label="0">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item required class="t-left">
              <span style="width: 200px" slot="label"
                >账号类型<el-tooltip
                  class="item"
                  effect="dark"
                  content="比如：张三用多个手机号开了账号，那么张三是主账号，其他是子账号。"
                  placement="right-start"
                  ><i class="el-icon-question"></i></el-tooltip
              ></span>
              <el-radio v-model="ruleForm.isChild" label="N">主账号</el-radio>
              <el-radio v-model="ruleForm.isChild" label="Y">子账号</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item required class="t-left">
              <span style="width: 200px" slot="label"
                >是否强管理<el-tooltip
                  class="item"
                  effect="dark"
                  content="强管理的业务员必须使用小程序才可记录行为轨迹哦"
                  placement="right-start"
                  ><i class="el-icon-question"></i></el-tooltip
              ></span>
              <el-radio v-model="ruleForm.isForceManage" label="Y">是</el-radio>
              <el-radio v-model="ruleForm.isForceManage" label="N">否</el-radio>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div
        slot="footer"
        class="dialog-footer"
        v-loading.fullscreen.lock="fullscreenLoading"
      >
        <el-button plain size="medium" @click="dialogFormVisible = false"
          >取消</el-button
        >
        <el-button
          size="medium"
          type="info"
          :loading="submitBtnLoading"
          v-if="textTitle == '新增人员'"
          @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button
          size="medium"
          type="info"
          :loading="submitBtnLoading"
          v-else
          @click="upDateForm('ruleForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 编辑标签弹框 -->
    <el-dialog
      :title="textTags"
      top="35vh"
      :visible.sync="dialogVisible1"
      width="600px"
    >
      <div class="edit-tags-text">
        <label class="w100"><span class="fontC-red">*</span>标签名称：</label>
        <el-input
          type="textarea"
          maxlength="50"
          :autosize="{ minRows: 2, maxRows: 3 }"
          placeholder="你可根据身份、角色、地域设置标签，如：领导/领导上级/三部总经理/数据专员/华南区等"
          v-model="tagForm.tagName"
        >
        </el-input>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
        v-loading.fullscreen.lock="fullscreenLoading"
      >
        <el-button plain size="medium" @click="dialogVisible1 = false"
          >取消</el-button
        >
        <el-button size="medium" type="info" @click="submitTags()"
          >确定</el-button
        >
        <!-- <el-button size="medium" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button> -->
      </div>
    </el-dialog>
    <!-- 查看标签详情弹框 -->
    <el-dialog
      title="查看标签详情"
      top="25vh"
      :visible.sync="dialogVisible2"
      width="600px"
    >
      <div class="tags-detail">
        <p class="tags-detail-title">
          <span class="tags-detail-name">标签名称：</span
          >{{ (tagsDetailData && tagsDetailData.labelName) || "-" }}
        </p>
        <p>
          <span class="tags-detail-name">包含成员：</span
          >{{ tagsDetailData && tagsDetailData.staffCount }}人
        </p>
        <p>
          <span class="tags-detail-name">包含部门：</span
          >{{ tagsDetailData && tagsDetailData.orgCount }}个
        </p>
        <p>
          <span class="tags-detail-name">标签创建人：</span
          >{{ (tagsDetailData && tagsDetailData.createUserName) || "-" }}
        </p>
        <p>
          <span class="tags-detail-name">创建时间：</span
          >{{ tagsDetailData && tagsDetailData.createTime | getDateSFM }}
        </p>
        <p>
          <span class="tags-detail-name">标签修改人：</span
          >{{ (tagsDetailData && tagsDetailData.updateUserName) || "-" }}
        </p>
        <p>
          <span class="tags-detail-name">修改时间：</span
          >{{ tagsDetailData && tagsDetailData.updateTime | getDateSFM }}
        </p>
      </div>
    </el-dialog>
    <!-- 新增部门/成员弹框 -->
    <el-dialog
      title="选择部门/人员"
      :visible.sync="visible3"
      width="60%"
      center
    >
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input
              v-model="filterText2"
              class="mt15"
              placeholder="请输入部门/人员名称"
            ></el-input>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :show-checkbox="true"
              node-key="guid"
              :filter-node-method="filterNodeDep"
              @node-click="handleNodeClick1"
              ref="treeDep"
              check-strictly
              :default-checked-keys="departList"
              @check-change="checkChange"
            >
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <img
                  v-if="data.nodeType == 1"
                  src="../../assets/images/ico_ora.png"
                  alt=""
                />
                <img v-else src="../../assets/images/icon_per.png" alt="" />
                <span>{{ data.name }}</span>
              </div>
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">
              已选{{ departmentList.length }}个部门/人员
            </p>
            <el-button
              size="medium"
              type="danger"
              @click="delDepartment()"
              class="fr"
              style="margin-top: 5px"
              >批量删除
            </el-button>
            <el-table
              :data="departmentList"
              border
              height="280px"
              style="width: 100%"
              @selection-change="handleSelectionChange1"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="organisationName"
                label="名称"
              >
                <template slot-scope="scope">
                  {{ scope.row.name }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false"
          >取消</el-button
        >
        <el-button size="medium" type="info" @click="submitDepartment()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 选择所属部门 -->
    <el-dialog
      title="选择所属部门"
      :visible.sync="showSetHead"
      width="800px"
      class="setHeadClass"
      :close-on-click-modal="false"
      @close="resetChoose"
    >
      <div class="setHead">
        <div class="left">
          <el-input
            placeholder="输入关键字进行过滤"
            size="small"
            style="margin: 6px 0"
            v-model="filterText1"
          >
          </el-input>
          <el-tree
            :data="superiorOrganization"
            ref="OrgTree"
            class="mt10 mb10"
            show-checkbox
            :check-strictly="true"
            node-key="guid"
            default-expand-all
            :default-checked-keys="defaultCheckedKeys"
            :filter-node-method="filterNode"
            @check-change="getCheckedNodesOfOrg"
            :props="defaultPropsOrganisation"
          >
          </el-tree>
        </div>
        <div class="right">
          <div class="top">
            <div class="btnArea">
              <span @click="deleteSelected">批量删除</span>
            </div>
          </div>
          <el-table
            :data="selectedData"
            height="500px"
            @selection-change="getTableSelect"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="organisationName" label="部门名称">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="comfirmChooseOrg" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 结束 -->
    <el-dialog
      :title="textTitle1"
      :visible.sync="dialogFormVisible1"
      width="550px"
    >
      <el-form
        :model="orgForm"
        :rules="rules1"
        ref="orgForm"
        label-width="120px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="药企方名称:" prop="tenantName">
          <el-input
            v-model="orgForm.tenantName"
            autocomplete="off"
            class="w100f"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="组织编码:" prop="TenantGuid">
          <el-input v-model="orgForm.TenantGuid" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <el-form-item label="组织编码:" prop="organisationCode">
          <el-input v-model="orgForm.organisationCode" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <el-form-item label="组织名称:" prop="organisationName">
          <el-input
            v-model="orgForm.organisationName"
            autocomplete="off"
            class="w100f"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="联系电话:" prop="contactTel">
          <el-input v-model="ruleForm.contactTel" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <el-form-item label="省市县:">
          <citys @incre="incres" :workareaList.sync="workareaList"></citys>
        </el-form-item> 
        <el-form-item label="地址:">
          <el-input v-model="ruleForm.address" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <el-form-item label="上级组织:">
          <el-cascader
            class="w100f"
            v-model="orgForm.parentGuid"
            placeholder="请选择"
            :options="superiorOrganization"
            :show-all-levels="false"
            :props="{
              value: 'guid',
              label: 'organisationName',
              children: 'children',
              checkStrictly: true,
            }"
            ref="cascader"
            clearable
            @change="getLevel"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="序号:" prop="orderNum">
          <el-input
            v-model="orgForm.orderNum"
            autocomplete="off"
            class="w100f"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="层级:" prop="level">
          <el-input v-model="ruleForm.level" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <el-form-item label="核算单元:" prop="bizUnitGuid">
          <div style="display: flex">
            <el-select
              v-model="orgForm.bizUnitGuid"
              placeholder="请选择"
              style="width: 70%; margin-right: 20px"
            >
              <el-option
                v-for="item in bizUnitNameOptions"
                :key="item.guid"
                :label="item.label"
                :value="item.guid"
              >
              </el-option>
            </el-select>
            <el-checkbox v-model="orgForm.updateUnitChild"
              >下级部门同时修改</el-checkbox
            >
          </div>
        </el-form-item>
        <el-form-item label="业务状态:" class="t-left">
          <el-radio v-model="orgForm.bizState" label="Y">有效</el-radio>
          <el-radio v-model="orgForm.bizState" label="S">停用</el-radio>
        </el-form-item>
        <el-form-item prop="isForceManage" class="t-left">
          <span slot="label">
            是否强管理:<el-tooltip
              class="item"
              effect="dark"
              content="强管理的业务员必须使用小程序才可记录行为轨迹哦"
              placement="right-start"
              ><i class="el-icon-question"></i
            ></el-tooltip>
          </span>
          <el-radio v-model="orgForm.isForceManage" label="Y">是</el-radio>
          <el-radio v-model="orgForm.isForceManage" label="N">否</el-radio>
          <!-- <el-checkbox v-model="orgForm.isChildForceManage">下级部门同时修改</el-checkbox> -->
        </el-form-item>
        <!-- <el-form-item label="是否运营管理级:" class="t-left">
          <el-radio v-model="orgForm.isOperationManageLevel" label="Y">是</el-radio>
          <el-radio v-model="orgForm.isOperationManageLevel" label="N">否</el-radio>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible1 = false"
          >取消</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-if="textTitle1 == '添加组织'"
          @click="submitOrgForm('orgForm')"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="upDateOrgForm('orgForm')"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import citys from '../../components/citys.vue';
import areaJson from "../../assets/js/china_address_v4.js";
import qs from "qs";
export default {
  components: {
    // citys,
  },
  data() {
    return {
      contentMainHeight: window.innerHeight - 194,
      contentMainHeight2: window.innerHeight - 140,
      tableHeight: window.innerHeight - 300,
      tableHeight2: window.innerHeight - 260,
      defaultCheckedKeys: [],
      workareaList: "",
      // input: '',
      textTitle: "",
      textTitle1: "",
      right: "",
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      dialogVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      fullscreenLoading: false,
      formLabelWidth: "120px",
      superiorOrganization: [],
      organisationGuidList: [],
      positionList: [],
      roleList: [],
      ruleForm: {
        guid: "",
        tenantGuid: "",
        tenantName: this.$route.query.tenantName,
        jobNumber: "",
        logonUser: "",
        staffName: "",
        helpCode: "",
        bizState: "Y",
        isActivity: "Y",
        isTask: "Y",
        isTeamLeader: "N",
        dutyStatus: "1",
        isShowLeaderTaskPercent: "N",
        mobileNo: "",
        email: "",
        isTenantInit: "N",
        leaderGuid: "",
        merchantGuid: "",
        organisationGuid: "",
        organisationGuids: [],
        salesTerritoryGuid: "",
        positionGuids: "",
        province: "",
        city: "",
        pwd: "",
        district: "",
        venue: "",
        address: "",
        sex: "M",
        staffType: "1",
        isCertAudit: "N",
        remark: "",
        weChatNo: "",
        weChatOpentId: "",
        idCode: "",
        roleGuids: [],
        isAdmin: "0", //是否管理员
        isPrimary: "N", //是否主账号
        isChild: "N",
        allocateNo: "", //货位ID
        isForceManage: "N",
      },
      orgForm: {
        guid: "",
        tenantGuid: "",
        tenantName: this.$route.query.tenantName,
        // organisationCode: '',
        organisationName: "",
        // contactTel: '',
        // province: '',
        // city: '',
        // district: '',
        // venue: '',
        // address: '',
        bizState: "Y",
        parentGuid: "",
        orderNum: "",
        level: 0,
        bizUnitGuid: "",
        updateUnitChild: false,
        isOperationManageLevel: "N",
        isForceManage: "N",
      },
      loading: false,
      defaultPropsOrganisation: {
        id: "guid",
        label: "organisationName",
        children: "children",
        // disabled: this.disabledTreeNode
      },
      // defaultPropsOrganisationCascader:{
      //    value: "guid",
      //    label: "organisationName",
      //    children:"children"
      // },
      //标签名称
      tagForm: {
        guid: "",
        tagName: "",
      },
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: "",
        logonUser: "",
        staffName: "",
        mobileNo: "",
        staffType: "",
        bizState: "",
        organisationGuid: "",
        salesTerritoryGuids: null,
      },
      isAllocateNo: false,
      staffDetail: "",
      tableData: [],
      rules1: {
        organisationName: [
          { required: true, message: "请输入组织名称", trigger: "blur" },
          { min: 1, max: 60, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        orderNum: [
          { required: true, message: "请输入序号", trigger: "blur" },
          { min: 1, max: 10000, message: "请输入序号", trigger: "blur" },
        ],
        isForceManage: [{ required: true, message: "请选择", trigger: "blur" }],
      },
      rules: {
        isForceManage: [{ required: true, message: "请选择", trigger: "blur" }],
        staffName: [
          {
            required: true,
            message: "请输入人员名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        staffType: [
          {
            required: true,
            message: "请输入人员类型",
            trigger: "blur",
          },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        logonUser: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        mobileNo: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        organisationGuids: [
          {
            required: true,
            message: "请输入所属部门",
            trigger: "change",
          },
          // { message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        // salesTerritoryGuid: [
        //   { required: true, message: '请选择销售区域', trigger: 'blur' },
        //   // { message: '长度在 3 到 5 个字符', trigger: 'blur' },
        // ],
        positionGuids: [
          {
            required: true,
            message: "请输入岗位",
            trigger: "blur",
          },
        ],
        roleGuids: [
          {
            required: true,
            message: "请输入角色",
            trigger: "blur",
          },
          // { message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
      },
      filterText: "",
      filterText1: "",
      multipleSelection: [],
      getSalesTerritoryList: [],
      salesTerritoryList: [],
      pwdSh: true,
      tabType: 1,
      tagsList: [],
      tagsIndex: 0,
      textTags: "添加标签",
      dialogVisible1: false,
      textarea1: "",
      dialogVisible2: false,
      visible3: false,
      filterText2: "",
      areaData: [],
      defaultProps: {
        id: "id",
        label: "label",
        children: "children",
      },
      departmentData: [],
      departmentList: [],
      area: [],
      delList: [],
      tableLoading: false,
      departList: [],
      pageTag: {
        pageIndex: 1,
        pageSize: -1,
        labelName: "",
        totalPage: 0,
        totalRows: 0,
      },
      pageDepTable: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
      tagGuid: "",
      tagsTable: [],
      loadingTagTable: false,
      tagsDetailData: "",
      tagTableGuidList: [],
      cascaderProps: {
        //角色级联
        value: "guid",
        label: "name",
        children: "children",
        multiple: true,
        emitPath: false,
      },
      //新增选择所属部门弹窗
      showSetHead: false,
      selectedData: [], //树选中
      tableSelected: [], //表格选中
      selectText: "",
      submitBtnLoading: false,
      options: areaJson, //调用外部js文件的json数据
      tenantName: "",
      deleteTips: null,
      bizStateOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "Y",
          label: "有效",
        },
        {
          value: "S",
          label: "停用",
        },
      ],
      staffTypeOptions: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "组内成员",
        },
        {
          value: "2",
          label: "备案成员",
        },
      ],
      organisationName: "",
      bizUnitNameOptions: [],
      parentGuid: "",
      editMobileNo: "",
    };
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 350;
        this.contentMainHeight = window.innerHeight - 244;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 300;
        this.contentMainHeight = window.innerHeight - 194;
        return;
      }
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    filterText1(val) {
      this.$refs.OrgTree.filter(val);
    },
    filterText2(val) {
      this.$refs.treeDep.filter(val);
    },
  },
  created() {
    this.getData(false);
    this.getAllSalesTerritory()
    this.tenantName = this.$route.query.tenantName;
    // if (this.$route.query.pageType) {
    //   this.tabType = this.$route.query.pageType;
    // }
    // 列表
    this.getData();
    this.getSuperiorOrganization();
    this.getAppsideData();
    this.getPositionListData();
    this.getOrganisation();
    this.getTagsList();
    this.getAllocateNo();
    this.getbizUnitNameOptions();
  },
  methods: {
    //批量导出
    batchExport() {
      let self = this;
      self.page.tenantGuid = self.$route.query.tenantGuid;
      let req=JSON.parse(JSON.stringify(self.page));
      req.pageIndex = 1
      req.pageSize = -1
      self.loading = true;
      self.api.postJsonD('/ms-personnel-service/staff/data/export-staff-info', req)
        .then(res => {
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          let fileName = '药企账户人员信息';
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a')
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.loading = false;
        });
    },
    //批量停用、启用
    batchChangeState(flg) {
      // flg为停用(s)启用(Y)状态
      let str=''
      let tips=''
      let self = this;
      if (!this.multipleSelection.length) {
        this.$message.error("请勾选数据！");
        return;
      }
      if(flg==='S'){
        str='停用后，服务人员将无法登录系统，确定操作吗？'
        tips='批量停用成功'
      }else{
        str='启用后，服务人员可正常登录系统，确定操作吗？'
        tips='批量启用成功'
      }
      
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        self.loading = true;
        self.api
            .put(
              `/${serverConfig.msPersonnelService}/staff/data/update-biz-state?bizState=${flg}`,
              self.multipleSelection
            )
            .then((res) => {
              self.loading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success(tips);
                self.$refs.multipleTable.clearSelection();
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
      })
    },
    
    getbizUnitNameOptions() {
      let self = this;
      let page = {
        pageIndex: 1,
        pageSize: 1000,
        tenantGuid: self.$route.query.tenantGuid,
      };
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/biz-unit/data/get-biz-unit`,
          self.page
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            var list = res.data.data.records;
            self.bizUnitNameOptions = list;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    renderContent(h, { node, data, store }) {
      if (data.bizState !== "Y") {
        return (
          <span>
            {node.label}{" "}
            <span style="display: inline-block;width: 48px;height: 21px;line-height: 21px;font-size:12px;background: rgba(239, 239, 239, 0.38);border-radius: 11px;margin-left: 5px;color:#6E6E6E;">
              无效
            </span>
          </span>
        );
      } else {
        return <span>{node.label}</span>;
      }
    },
    //正式 89a3261c262411ebad37fa163e4b37cf
    //测试 1aaf025422ff11eb9405080027ac9e40
    //是否存在有货位ID的
    getAllocateNo() {
      let that = this;
      let id = "1aaf025422ff11eb9405080027ac9e40";
      if (
        location.href.indexOf("https://scm-operation.csyaoly.com") > -1 ||
        location.href.indexOf("https://scm-operation.cs4pl.com") > -1
      ) {
        id = "89a3261c262411ebad37fa163e4b37cf";
      } else {
        id = "1aaf025422ff11eb9405080027ac9e40";
      }
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${id}&code=ZSHWID`
        )
        .then((resp) => {
          console.log(resp.data);
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            let arr = [];
            data.forEach((item) => {
              if (item.parameterValue == this.$route.query.tenantGuid) {
                that.isAllocateNo = true;
                console.log(that.isAllocateNo);
              }
            });
          }
        });
    },
    isContainOrg(arr, guid) {
      if (!arr.length) return 0;
      let flag = arr.findIndex((one) => {
        return one == guid;
      });
      if (flag == -1) {
        return 0;
      } else {
        return 1;
      }
    },
    disabledTreeNode(data, node) {
      let list = this.selectedData;
      if (list.length) {
        let flag = 0;
        let parentGuids = data.parentGuids ? data.parentGuids : [];
        for (let i = 0; i < list.length; i++) {
          let checkedParentGuids = list[i].parentGuids
            ? list[i].parentGuids
            : [];
          if (this.isContainOrg(parentGuids, list[i].guid)) {
            flag = 1;
            break;
          } else if (this.isContainOrg(checkedParentGuids, data.guid)) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        return flag > 0;
      } else {
        return false;
      }
    },
    //根据手机号查询邮箱地址
    getInfoByMobileNo() {
      if (this.ruleForm.mobileNo) {
        let regs =
          /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
        if (regs.test(this.ruleForm.mobileNo)) {
          let params = {
            pageIndex: 1,
            pageSize: 10,
            staffOrMobileNo: this.ruleForm.mobileNo,
            serviceTenantGuid: this.$store.state.guid,
          };
          let url = `/${
            serverConfig.msPersonnelService
          }/staff-roster/list?${qs.stringify(params)}`;
          this.api.postJson(url).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if (res.data.data.records) {
                let data = res.data.data.records[0];
                this.ruleForm.email = data.email;
                this.ruleForm.venue = data.liverAddress;
                this.ruleForm.address = data.detailAddress;
                this.workareaList = data.liverAddress
                  ? data.liverAddress.split("/")
                  : [];
                console.log(this.workareaList);
                this.ruleForm.sex = data.sex;
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          this.$message.warning("手机号格式不正确！");
        }
      }
    },
    //新增选择所属部门----------
    setTableHead(type) {
      //设置树组件选中数据
      this.showSetHead = true;
      if (this.ruleForm.organisationGuids.length) {
        this.$nextTick(() => {
          this.$refs.OrgTree.setCheckedKeys(this.ruleForm.organisationGuids);
          this.selectedData = this.$refs.OrgTree.getCheckedNodes();
        });
      }
    },
    getCheckedNodesOfOrg() {
      let resultData = this.$refs.OrgTree.getCheckedNodes();
      if (resultData.length < 6) {
        this.selectedData = resultData;
      } else {
        this.$message.warning("一个人员同一家公司最多只能属于5个部门!");
        this.$refs.OrgTree.setCheckedNodes(this.selectedData);
      }
    },
    //获取表格选中
    getTableSelect(val) {
      this.tableSelected = val;
    },
    //批量删除
    deleteSelected() {
      if (this.tableSelected.length == 0) {
        this.$message.error("请勾选需要删除的内容");
        return;
      }
      this.selectedData = this.$refs.OrgTree.getCheckedNodes();
      let newArr = [];
      newArr = this.selectedData.filter((item) =>
        this.tableSelected.every((one) => one.guid !== item.guid)
      );
      this.$refs.OrgTree.setCheckedNodes(newArr); //设置树组件的选中
    },
    //部门选择重置选项
    resetChoose() {
      this.tableSelected = [];
      this.showSetHead = false;
    },
    //选择部门确认
    comfirmChooseOrg() {
      let arr = [];
      let str = "";
      console.log(this.selectedData);
      this.selectedData.forEach((item) => {
        arr.push(item.guid);
        str += item.organisationName + "、";
      });
      this.selectText = str ? str.slice(0, str.length - 1) : "";
      this.ruleForm.organisationGuids = arr;
      this.$refs.OrgTree.setCheckedKeys([]);
      this.showSetHead = false;
      if (this.ruleForm.organisationGuids.length) {
        this.getSalesTerritory();
      }
    },
    tagChange() {
      this.getTagsList();
    },
    //获取组织
    getOrganisation() {
      let self = this;
      let query = {
        tenantGuid: localStorage.guid,
        // sendTenantGuid:localStorage.guid 加权限要
      };
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/organisation/data/get-tree`,
          query
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
            this.treeData(self.areaData);
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
          }
        });
    },
    //查询人员
    getStaff(organisationGuid) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: 10,
        tenantGuid: self.$route.query.tenantGuid,
        staffType: "1",
        bizState: "Y",
        organisationGuid: organisationGuid,
      };
      return new Promise((resolve, reject) => {
        self.api
          .postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              // self.tableLoading = false;
              const records = res.data.data.records;
              (records || []).forEach((k) => {
                k.label = k.staffName;
                k.id = k.guid;
                k.icon = require("../../assets/images/icon_per.png");
              });
              resolve(records);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    treeData(areaData) {
      var self = this;
      const fn = (tree) => {
        tree.forEach(async (k) => {
          // if(k.nodeType==1){
          //     k.disabled = true;
          // }
          // 根据id获取人员数据,(注意转为树类型)
          if (k) {
            const isValid = (val) => {
              return val && val !== null && JSON.stringify(val) !== "[]";
            };
            // 将人员数据拼接到chilren里面
            if (k.children) {
              fn(k.children);
              k.children = [...k.children];
              // 有子元素，需要调用自身
            }
          }
        });
      };
      fn(areaData);
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //选项卡
    tabChange(type) {
      this.pageTag.labelName = "";
      this.tabType = type;
      if (type == 2) {
        this.getTagsList();
      }
    },
    //获取标签列表
    getTagsList() {
      let self = this;
      let tenantGuid = self.$route.query.tenantGuid;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/label/list?` +
            "pageIndex=" +
            this.pageTag.pageIndex +
            "&pageSize=" +
            this.pageTag.pageSize +
            `&tenantGuid=` +
            tenantGuid +
            "&labelName=" +
            this.pageTag.labelName
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data.records !== null) {
              self.tagsList = res.data.data.records;
              if (!this.tagForm.guid) {
                self.tagGuid = self.tagsList[0].guid;
                this.tagsIndex = 0;
              }
              this.getTagsTable();
              this.tagsDetail();
            } else {
              self.tagsList = [];
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //添加标签
    addTagsList(item) {
      this.dialogVisible1 = true;
      if (item) {
        this.textTags = "编辑标签";
        this.tagForm.guid = item.guid;
        this.tagForm.tagName = item.labelName;
      } else {
        this.textTags = "添加标签";
        this.tagForm.guid = "";
        this.tagForm.tagName = "";
      }
    },
    //选中标签
    tagsSelect(item, index) {
      if (this.tagsList.length > 0) {
        this.tagsIndex = index;
        this.tagsList[index].type = 1;
        this.tagGuid = item.guid;
        this.getTagsTable();
        this.tagsDetail();
      }
    },

    //提交标签编辑
    submitTags() {
      let self = this;
      if (this.tagForm.tagName == "") {
        this.$message.error("请输入标签名称！");
        return;
      }
      if (this.tagForm.guid) {
        let promise = {
          guid: this.tagForm.guid,
          tenantGuid: self.$route.query.tenantGuid,
          labelName: this.tagForm.tagName,
        };
        this.api
          .put(`/${serverConfig.msPersonnelService}/label/update`, promise)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success("修改成功！");
              this.getTagsList();
              this.dialogVisible1 = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else {
        let promise = {
          guid: this.tagForm.guid,
          tenantGuid: self.$route.query.tenantGuid,
          labelName: this.tagForm.tagName,
        };
        this.api
          .postJson(`/${serverConfig.msPersonnelService}/label/add`, promise)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success("新增成功！");
              this.getTagsList();
              this.dialogVisible1 = false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
      }
    },
    //查看标签详情
    tagsDetail(type) {
      let self = this;
      if (this.tagsList.length < 1) {
        this.$message.error("暂无标签，请先添加标签");
        return;
      }
      if (type) {
        this.dialogVisible2 = true;
      }
      let tenantGuid = self.$route.query.tenantGuid;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/label/detail/${tenantGuid}/` +
            this.tagGuid
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.tagsDetailData = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //删除标签
    tagsDel(guid) {
      let self = this;
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/label/del`, [guid])
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success("删除成功");
            this.getTagsList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error("请勾选部门！");
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      this.$refs.treeDep.setCheckedNodes(this.departmentList);
      // self.delList.forEach(function (m) {
      //   self.area.forEach(function (n, idn) {
      //     if (JSON.parse(n).guid == m.guid) {
      //       self.area.splice(idn, 1);
      //     }
      //   });
      // });
    },
    addDepartment() {
      if (this.tagsList.length < 1) {
        this.$message.error("暂无标签，请先添加标签");
        return;
      }
      this.visible3 = true;
      this.departmentList = [];
      this.$refs.treeDep.setCheckedNodes(this.departmentList);
      // this.getOrganisation();
    },
    //多选移出
    handleSelectionChangeTag(val) {
      val.forEach((item) => {
        //item 就是当日按循环到的对象
        this.tagTableGuidList.push(item.guid);
      });
    },
    //移出部门/人员
    getDeleteDep() {
      let self = this;
      if (this.tagTableGuidList.length < 1) {
        self.$message.error("请先勾选数据！");
        return;
      }
      let query = {
        tenantGuid: self.$route.query.tenantGuid,
        organisationLabelGuid: this.tagGuid,
        guids: this.tagTableGuidList,
      };
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/label/members/remove`,
          query
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success("删除成功");
            this.getTagsList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // unique(arr) {
    //   return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
    // },
    checkChange(val) {
      console.log(this.$refs.treeDep.getCheckedNodes());
      this.departmentList = this.$refs.treeDep.getCheckedNodes();
      console.log(this.departList);
      console.log("22222222222", val);
    },
    //提交选择的人或部门
    submitDepartment() {
      if (this.departmentList.length < 1) {
        this.$message.error("请选择部门或人员！");
        return;
      }
      let orgGuids = [];
      let staffGuids = [];
      console.log(this.departmentList);
      this.departmentList.forEach((i) => {
        if (i.nodeType == 2) {
          staffGuids.push(i.guid);
        } else {
          orgGuids.push(i.guid);
        }
      });
      this.api
        .postJson(
          `/${serverConfig.msPersonnelService}/label/members/add`,
          query
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success("添加成功！");
            this.getTagsTable();
            this.visible3 = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      console.log("9999999", query);
    },
    //部门弹框选择
    handleNodeClick1(data) {
      let self = this;
      console.log(data);
      // let item = {
      //   guid: data.guid,
      //   organisationName: data.staffName ? data.staffName: data.organisationName,
      // };
      // // self.area = [];
      // self.area.push(JSON.stringify(item));
      // self.area = self.unique(self.area);
      // self.departmentList = [];
      // self.area.forEach(function (i) {
      //   self.departmentList.push(JSON.parse(i));
      // });
      console.log(self.departmentList);
    },
    //获取人员部门表格
    getTagsTable() {
      let self = this;
      this.loadingTagTable = true;
      let tenantGuid = self.$route.query.tenantGuid;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/label/members/list?labelGuid=` +
            this.tagGuid +
            "&pageIndex=" +
            this.pageDepTable.pageIndex +
            "&pageSize=" +
            this.pageDepTable.pageSize +
            `&tenantGuid=` +
            tenantGuid
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.loadingTagTable = false;
            if (res.data.data.records !== null) {
              self.tagsTable = res.data.data.records;
              self.pageDepTable.totalPage = res.data.data.totalPages;
              self.pageDepTable.totalRows = res.data.data.totalRows;
              // self.tagGuid = self.tagsList[0].guid
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleSizeChangeTagTable(val) {
      let self = this;
      self.pageTagTable.pageSize = val;
      this.getTagsTable();
    },
    handleCurrentChangeTagTable(val) {
      let self = this;
      self.pageTagTable.pageIndex = val;
      this.getTagsTable();
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
    getUser: function () {
      var self = this;
      if (self.textTitle == "新增人员") {
        self.api
          .postJson(
            `/${serverConfig.msUserUnifiedAuthenticationService}/user/get-user`,
            {
              username: self.ruleForm.logonUser,
            }
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if (res.data.data == null) {
                self.pwdSh = true;
              } else {
                self.pwdSh = false;
                // self.$alert(
                //   "您注册的账号已存在，不用输入密码。请继续操作。如忘记密码，请进行重置密码操作",
                //   "提示",
                //   {
                //     confirmButtonText: "确定",
                //     callback: (action) => {},
                //   }
                // );
                self.$message.error('您注册的账号已存在，不用输入密码。请继续操作。如忘记密码，请进行重置密码操作');
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
      }
    },
    incres(area) {
      const checkedNodes = this.$refs["cascaderFirst"].getCheckedNodes();
      console.log(checkedNodes, "ljx");
      let arr = checkedNodes[0].pathNodes;
      let codeArr = [];
      arr.forEach((item) => {
        codeArr.push(item.data.value);
      });
      this.ruleForm.province = codeArr[0];
      this.ruleForm.city = codeArr[1];
      this.ruleForm.district = codeArr[2];
      this.ruleForm.venue = area.join("/");
    },
    handleNodeCilck(data) {
      // console.log(data);
      let self = this;
      self.selectedData = [];
      self.page.totalRows = 0;
      self.ruleForm.organisationGuids = [];
      self.selectedData.push(data);
      self.selectText = data.organisationName;
      self.page.organisationGuid = "";
      self.ruleForm.organisationGuids.push(data.guid);
      self.page.containChildOrganisationGuid = data.guid;
      self.organisationName = data.organisationName;

      self.getData(true);
      // node.
    },
    getSuperiorOrganization() {
      let self = this;
      let tenantGuid = self.$route.query.tenantGuid;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?` +
            `tenantGuid=` +
            tenantGuid
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.superiorOrganization = res.data.data;
            self.data = JSON.parse(JSON.stringify(self.superiorOrganization));
            if (
              self.superiorOrganization &&
              self.superiorOrganization.length > 0
            ) {
              self.organisationName =
                self.superiorOrganization[0].organisationName;
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getAppsideData() {
      let self = this;
      let promise = {
        guid: "",
        pageIndex: 1,
        appSideName: "",
        pageSize: 100,
        startTime: "",
        endTime: "",
        platformGuid: "1e2409b7ef0b412c2bb84e38f8fe50ba",
      };
      self.api
        .postJson(
          `/${serverConfig.msCommonAdminPlatformAuthService}/appside/data/get`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let appsideList = res.data.data.records;
            self.roleList = [];
            appsideList.forEach(function (item) {
              item.name = item.appSideName;
              self.getRoleListData(item);
            });
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getRoleListData(oneData) {
      let self = this;
      let promise = {
        bizState: "Y",
        tenantGuid: self.$route.query.tenantGuid,
        appSideGuid: oneData.guid,
        pageSize: 100,
        isAdmin: JSON.parse(localStorage.userInfo).isAdmin,
      };
      self.api
        .postJson(
          `/${serverConfig.msCommonAdminPlatformAuthService}/role/data/get`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = res.data.data.records ? res.data.data.records : [];
            // if (roleList != null) {
            //   roleList.forEach(function (j) {
            //     let item = {
            //       guid: j.guid,
            //       roleName: j.roleName,
            //       appSideName: j.appSideName,
            //     };
            //     self.roleList.push(item);
            //   });
            // }
            data.forEach((item) => {
              item.name = item.roleName;
            });
            oneData.children = data;
            self.roleList.push(oneData);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getPositionListData() {
      let self = this;
      let promise = {
        tenantGuid: self.$route.query.tenantGuid,
        pageSize: 10000,
      };
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/position/data/get`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.positionList = res.data.data.records;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: self.$route.query.tenantGuid,
        logonUser: "",
        staffName: "",
        mobileNo: "",
        staffType: "",
        bizState: "",
        organisationGuid: "",
        salesTerritoryGuids: null,
      };
      self.getData(true);
    },
    add(flg, row) {
      let self = this;
      self.workareaList = [];
      // self.getSuperiorOrganization();
      self.defaultCheckedKeys = [];
      // self.selectText = ''
      // self.selectedData = [];
      if (flg == 1) {
        self.textTitle = "新增人员";
        self.ruleForm.jobNumber = "";
        self.ruleForm.logonUser = "";
        self.ruleForm.staffName = "";
        self.ruleForm.bizState = "Y";
        self.ruleForm.isActivity = "Y";
        self.ruleForm.isTask = "Y";
        self.ruleForm.isTeamLeader = "N";
        self.ruleForm.dutyStatus = "1";
        self.ruleForm.isShowLeaderTaskPercent = "N";
        self.ruleForm.mobileNo = "";
        self.ruleForm.email = "";
        self.ruleForm.isTenantInit = "N";
        self.ruleForm.leaderGuid = "";
        self.ruleForm.merchantGuid = "";
        self.ruleForm.organisationGuid = [];
        self.defaultCheckedKeys = [];
        self.ruleForm.salesTerritoryGuid = "";
        self.ruleForm.positionGuids = "";
        self.ruleForm.province = "";
        self.ruleForm.city = "";
        self.ruleForm.pwd = "";
        self.ruleForm.district = "";
        self.ruleForm.venue = "";
        self.ruleForm.address = "";
        self.ruleForm.sex = "M";
        self.ruleForm.staffType = "1";
        self.ruleForm.isCertAudit = "N";
        self.ruleForm.remark = "";
        self.ruleForm.weChatNo = "";
        self.ruleForm.weChatOpentId = "";
        self.ruleForm.weChatOpentId = "";
        self.ruleForm.idCode = "";
        self.ruleForm.roleGuids = [];
        self.ruleForm.guid = "";
        self.ruleForm.isPrimary = "N";
        self.ruleForm.isAdmin = "0";
        self.ruleForm.isChild = "N";
        self.ruleForm.allocateNo = "";
        self.ruleForm.isOperationManageLevel = "N";
        self.dialogFormVisible = true;
      } else {
        self.textTitle = "编辑人员";
        self.selectText = "";
        self.selectedData = [];
        self.ruleForm.organisationGuids = [];

        self.ruleForm.guid = row.guid;
        self.workareaList.push(row.province, row.city, row.district);
        self.getStaffDetail(row.guid);
      }
    },
    getData(flg) {
      let self = this;
      self.loading = true;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.page.tenantGuid = self.$route.query.tenantGuid;
      self.api
        .postJson(
          `/${serverConfig.msPersonnelService}/staff/data/get`,
          self.page
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.loading = false;
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getStaffDetail(guid) {
      let self = this;
      self.staffDetail = "";
      self.defaultCheckedKeys = [];
      self.ruleForm.organisationGuids = [];
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/staff/data/get-staff-detail?` +
            `guid=` +
            guid
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.staffDetail = res.data.data;
            self.editMobileNo = JSON.parse(
              JSON.stringify(res.data.data.mobileNo)
            );
            let guids = [];
            self.ruleForm.jobNumber = self.staffDetail.jobNumber;
            self.ruleForm.logonUser = self.staffDetail.logonUser;
            self.ruleForm.staffName = self.staffDetail.staffName;
            self.ruleForm.bizState = self.staffDetail.bizState;
            self.ruleForm.isActivity = self.staffDetail.isActivity;
            self.ruleForm.isTask = self.staffDetail.isTask;
            self.ruleForm.isTeamLeader = self.staffDetail.isTeamLeader;
            self.ruleForm.dutyStatus = self.staffDetail.dutyStatus;
            self.ruleForm.isShowLeaderTaskPercent =
              self.staffDetail.isShowLeaderTaskPercent;

            self.ruleForm.mobileNo = self.staffDetail.mobileNo;
            self.ruleForm.email = self.staffDetail.email;
            self.ruleForm.pwd = "";
            self.ruleForm.isTenantInit = self.staffDetail.isTenantInit;
            self.ruleForm.leaderGuid = self.staffDetail.leaderGuid;
            self.ruleForm.merchantGuid = self.staffDetail.merchantGuid;
            self.ruleForm.isPrimary = self.staffDetail.isPrimary;
            self.ruleForm.isAdmin = self.staffDetail.isAdmin;
            self.ruleForm.isChild = self.staffDetail.isChild;
            self.ruleForm.allocateNo = self.staffDetail.allocateNo;
            // self.ruleForm.organisationGuid = self.staffDetail.organisationGuid;
            if (self.staffDetail.organisationGuids != null) {
              self.defaultCheckedKeys = self.staffDetail.organisationGuids;
              self.ruleForm.organisationGuids =
                self.staffDetail.organisationGuids;
              self.selectText = self.staffDetail.organisationNames.join("，");
            }
            if (self.staffDetail.positionGuids != null) {
              self.ruleForm.positionGuids = self.staffDetail.positionGuids[0];
            }
            self.ruleForm.salesTerritoryGuid =
              self.staffDetail.salesTerritoryGuid;
            self.ruleForm.province = self.staffDetail.province;
            self.ruleForm.city = self.staffDetail.city;
            self.ruleForm.district = self.staffDetail.district;
            self.ruleForm.venue = self.staffDetail.venue;
            self.ruleForm.address = self.staffDetail.address;
            self.ruleForm.sex = self.staffDetail.sex;
            self.ruleForm.staffType = self.staffDetail.staffType;
            self.ruleForm.isCertAudit = self.staffDetail.isCertAudit || "N";
            self.ruleForm.remark = self.staffDetail.remark;
            self.ruleForm.weChatNo = self.staffDetail.weChatNo;
            self.ruleForm.weChatOpentId = self.staffDetail.weChatOpentId;
            self.ruleForm.weChatOpentId = self.staffDetail.weChatOpentId;
            self.ruleForm.idCode = self.staffDetail.idCode;
            self.ruleForm.roleGuids = self.staffDetail.roleGuids;
            self.ruleForm.isForceManage = self.staffDetail.isForceManage || "N";
            self.workareaList = self.staffDetail.venue
              ? self.staffDetail.venue.split("/")
              : [];
            self.dialogFormVisible = true;
            self.getSalesTerritory();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      if (val && val.length > 0) {
        val.forEach(function (item) {
          //item 就是当日按循环到的对象
          self.multipleSelection.push(item.guid);
        });
      }
      console.log(val);
    },
    //获取客户列表
    getCustomerList(tenantGuid, staffGuid) {
      let self = this;
      let query = {
        tenantGuid,
        staffGuid: [staffGuid],
      };
      this.deleteTips = null;
      return new Promise((resolve, reject) => {
        self.api
          .postJson(
            `/${serverConfig.msPersonnelService}/duty-transform/staff-get-customer`,
            query
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let data = res.data.data;
              if (data) {
                data.forEach((i) => {
                  if (
                    i.customerInfo.customer ||
                    i.customerInfo.doctors ||
                    i.customerInfo.franchisees ||
                    i.customerInfo.medList ||
                    i.customerInfo.patients ||
                    i.customerInfo.potentialCustomer ||
                    i.customerInfo.potentialFranchisees
                  ) {
                    this.deleteTips =
                      "此人员存在客户数据，请先办理离职，交接客户资源后，才可删除！";
                  }
                });
              }
              resolve();
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    async getDeleteData(flg, guid, tenantGuid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error("请勾选数据！");
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      let DeleteStaffRequestVO = {
        guids: self.multipleSelection,
        tenantGuid: self.$store.getters.getTenantGuid,
        isVaildInitStaff: true,
        sendTenantGuid: this.$route.query.tenantGuid
      };
      await this.getCustomerList(tenantGuid, guid);
      if (this.deleteTips) {
        self.$message.error(this.deleteTips);
        return;
      }
      this.$confirm("删除后不可恢复，确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          self.api
            .postJson(
              `/${serverConfig.msPersonnelService}/staff/data/delete-by-tenant`,
              DeleteStaffRequestVO
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success("删除人员成功");
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    resetPwd(guid) {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCommonAdminPlatformAuthService}/user/data/resetPwd?userGuid=${guid}`
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success("重置密码成功，密码为：Aa666666+");
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // handleCheckChange(data, checked, indeterminate) {
    //   if (checked) {
    //     if (this.ruleForm.organisationGuids.length < 5) {
    //       if (this.ruleForm.organisationGuids.indexOf(data.guid) == -1) {
    //         this.ruleForm.organisationGuids.push(data.guid);
    //       }
    //     } else {
    //       this.$message.warning('一个人员同一家公司最多只能属于5个部门!')
    //       this.$refs.tree1.setCheckedKeys(this.ruleForm.organisationGuids)
    //     }
    //   } else {
    //     this.ruleForm.organisationGuids.forEach((item, index) => {
    //       if (item == data.guid) {
    //         this.ruleForm.organisationGuids.splice(index, 1);
    //       }
    //     });
    //   }

    //   // this.getSalesTerritory();
    // },
    //获取组织的销售区域
    getSalesTerritory() {
      let self = this;
      let tenantGuid = self.$route.query.tenantGuid;
      let promise = {
        tenantGuid: tenantGuid,
        organisationGuids: self.ruleForm.organisationGuids,
        pageIndex: 1,
        pageSize: 100,
      };
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/sales-territory/data/get-sales-territory`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data.records != null) {
              self.getSalesTerritoryList = res.data.data.records;
              // self.page.totalRows = res.data.data.totalRows;
            } else {
              self.getSalesTerritoryList = [];
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getAllSalesTerritory() {
      let self = this;
      let tenantGuid = self.$route.query.tenantGuid;
      let promise = {
        tenantGuid: tenantGuid,
        pageIndex: 1,
        pageSize: 100,
      };
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/sales-territory/data/get-sales-territory`,
          promise
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data.records != null) {
              self.salesTerritoryList = res.data.data.records;
            } else {
              self.salesTerritoryList = [];
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    submitForm(formName) {
      // console.log('ruleForm', this.ruleForm)
      let self = this;
      let getSalesTerritoryList = this.getSalesTerritoryList;
      let salesTerritoryName;
      let positionGuids = [];
      positionGuids.push(self.ruleForm.positionGuids);
      getSalesTerritoryList.forEach((item) => {
        if (item.guid == self.ruleForm.salesTerritoryGuid) {
          salesTerritoryName = item.territoryName;
        }
      });
      // console.log(salesTerritoryName)
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let pwd = self.$md5(self.ruleForm.pwd);
          let promise = {
            tenantGuid: self.$store.getters.getTenantGuid,
            sendTenantGuid: self.$route.query.tenantGuid,
            jobNumber: self.ruleForm.jobNumber,
            logonUser: self.ruleForm.logonUser,
            staffName: self.ruleForm.staffName,
            helpCode: self.ruleForm.helpCode,
            pwd: pwd,
            isActivity: self.ruleForm.isActivity,
            isTask: self.ruleForm.isTask,
            isTeamLeader: self.ruleForm.isTeamLeader,
            isShowLeaderTaskPercent: self.ruleForm.isShowLeaderTaskPercent,
            dutyStatus: self.ruleForm.dutyStatus,
            bizState: self.ruleForm.bizState,
            mobileNo: self.ruleForm.mobileNo,
            email: self.ruleForm.email,
            isTenantInit: self.ruleForm.isTenantInit,
            leaderGuid: self.ruleForm.leaderGuid,
            merchantGuid: self.ruleForm.merchantGuid,
            // organisationGuid: self.ruleForm.organisationGuid.toString(),
            organisationGuids: self.ruleForm.organisationGuids,
            positionGuids: positionGuids,
            salesTerritoryGuid: self.ruleForm.salesTerritoryGuid,
            salesTerritoryName: salesTerritoryName,
            province: self.ruleForm.province,
            city: self.ruleForm.city,
            district: self.ruleForm.district,
            venue: self.ruleForm.venue,
            address: self.ruleForm.address,
            sex: self.ruleForm.sex,
            staffType: self.ruleForm.staffType,
            isCertAudit:
              self.ruleForm.staffType == "2" ? self.ruleForm.isCertAudit : null,
            remark: self.ruleForm.remark,
            weChatNo: self.ruleForm.weChatNo,
            weChatOpentId: self.ruleForm.weChatOpentId,
            idCode: self.ruleForm.idCode,
            roleGuids: self.ruleForm.roleGuids,
            isPrimary: self.ruleForm.isPrimary,
            isAdmin: self.ruleForm.isAdmin,
            isChild: self.ruleForm.isChild,
            allocateNo: self.ruleForm.allocateNo,
            isForceManage: self.ruleForm.isForceManage,
          };
          if (promise.logonUser !== promise.mobileNo) {
            this.$message.error("账号和手机号请保持一致！");
            return;
          }
          // self.fullscreenLoading = true;
          self.submitBtnLoading = true;
          self.api
            .postJson(
              `/${serverConfig.msPersonnelService}/staff/data/add`,
              promise
            )
            .then((res) => {
              // self.fullscreenLoading = false;
              self.submitBtnLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dialogFormVisible = false;
                self.ruleForm.organisationGuids = [];
                self.selectText = "";
                self.$message.success("添加人员成功");
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
      let getSalesTerritoryList = this.getSalesTerritoryList;
      let salesTerritoryName;
      let positionGuids = [];
      positionGuids.push(self.ruleForm.positionGuids);
      getSalesTerritoryList.forEach((item) => {
        if (item.guid == self.ruleForm.salesTerritoryGuid) {
          salesTerritoryName = item.territoryName;
        }
      });
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let pwd = self.$md5(self.ruleForm.pwd);
          let promise = {
            guid: self.ruleForm.guid,
            tenantGuid: self.$store.getters.getTenantGuid,
            sendTenantGuid: self.$route.query.tenantGuid,
            jobNumber: self.ruleForm.jobNumber,
            logonUser: self.ruleForm.logonUser,
            staffName: self.ruleForm.staffName,
            helpCode: self.ruleForm.helpCode,
            pwd: pwd,
            isActivity: self.ruleForm.isActivity,
            isTask: self.ruleForm.isTask,
            isTeamLeader: self.ruleForm.isTeamLeader,
            isShowLeaderTaskPercent: self.ruleForm.isShowLeaderTaskPercent,
            dutyStatus: self.ruleForm.dutyStatus,
            bizState: self.ruleForm.bizState,
            mobileNo: self.ruleForm.mobileNo,
            email: self.ruleForm.email,
            isTenantInit: self.ruleForm.isTenantInit,
            leaderGuid: self.ruleForm.leaderGuid,
            merchantGuid: self.ruleForm.merchantGuid,
            // organisationGuid: self.ruleForm.organisationGuid.toString(),
            organisationGuids: self.ruleForm.organisationGuids,
            positionGuids: positionGuids,
            salesTerritoryGuid: self.ruleForm.salesTerritoryGuid,
            salesTerritoryName: salesTerritoryName,
            province: self.ruleForm.province,
            city: self.ruleForm.city,
            district: self.ruleForm.district,
            venue: self.ruleForm.venue,
            address: self.ruleForm.address,
            sex: self.ruleForm.sex,
            staffType: self.ruleForm.staffType,
            isCertAudit:
              self.ruleForm.staffType == "2" ? self.ruleForm.isCertAudit : null,
            remark: self.ruleForm.remark,
            weChatNo: self.ruleForm.weChatNo,
            weChatOpentId: self.ruleForm.weChatOpentId,
            idCode: self.ruleForm.idCode,
            roleGuids: self.ruleForm.roleGuids,
            isPrimary: self.ruleForm.isPrimary,
            isAdmin: self.ruleForm.isAdmin,
            isChild: self.ruleForm.isChild,
            allocateNo: self.ruleForm.allocateNo,
            isForceManage: self.ruleForm.isForceManage,
          };
          if (promise.logonUser !== promise.mobileNo) {
            this.$message.error("账号和手机号请保持一致！");
            return;
          }
          if (self.editMobileNo == promise.mobileNo || !self.ruleForm.guid) {
            // self.fullscreenLoading = true;
            self.submitBtnLoading = true;
            self.api
              .put(
                `/${serverConfig.msPersonnelService}/staff/data/update`,
                promise
              )
              .then((res) => {
                // self.fullscreenLoading = false;
                self.submitBtnLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  self.dialogFormVisible = false;
                  self.ruleForm.organisationGuids = [];
                  self.selectText = "";
                  self.$message.success("编辑人员成功");
                  self.getData(true);
                } else {
                  self.$message.error(res.data.msg);
                }
              });
          } else {
            self
              .$confirm("手机号有变更，确定修改吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
              .then(() => {
                // self.fullscreenLoading = true;
                self.submitBtnLoading = true;
                self.api
                  .put(
                    `/${serverConfig.msPersonnelService}/staff/data/update`,
                    promise
                  )
                  .then((res) => {
                    // self.fullscreenLoading = false;
                    self.submitBtnLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                      self.dialogFormVisible = false;
                      self.ruleForm.organisationGuids = [];
                      self.selectText = "";
                      self.$message.success("编辑人员成功");
                      self.getData(true);
                    } else {
                      self.$message.error(res.data.msg);
                    }
                  });
              })
              .catch(() => {
                self.$message({
                  type: "info",
                  message: "已取消操作",
                });
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    getLevel(val) {
      let self = this;
      console.log("789", val, val.length);
      if (val.length > 0) {
        self.parentGuid = val[val.length - 1].toString();
      }
      // console.log(self.ruleForm.level);
    },
    addAppend(data) {
      let self = this;
      self.textTitle1 = "添加组织";
      self.orgForm.guid = "";
      self.orgForm.tenantGuid = data.tenantGuid;
      self.orgForm.organisationName = "";
      self.orgForm.orderNum = "";
      self.orgForm.level = "";
      self.orgForm.bizState = data.bizState;
      self.orgForm.parentGuid = data.guid;
      self.parentGuid = data.guid;
      self.orgForm.bizUnitGuid = "";
      self.orgForm.updateUnitChild = false;
      self.orgForm.isOperationManageLevel = "N";

      self.orgForm.isForceManage = "N";

      self.dialogFormVisible1 = true;
      console.log(data);
    },
    append(data) {
      let self = this;
      self.textTitle1 = "编辑组织";
      self.orgForm.guid = data.guid;
      self.orgForm.tenantGuid = data.tenantGuid;
      self.orgForm.organisationName = data.organisationName;
      self.orgForm.orderNum = data.orderNum;
      self.orgForm.level = Number(data.level);
      self.orgForm.bizState = data.bizState;
      self.orgForm.parentGuid = data.parentGuid;
      self.parentGuid = data.parentGuid;
      self.orgForm.bizUnitGuid = data.bizUnitGuid;
      self.orgForm.updateUnitChild = data.updateUnitChild;
      self.orgForm.isOperationManageLevel = data.isOperationManageLevel;
      self.orgForm.isForceManage = data.isForceManage || "N";
      self.dialogFormVisible1 = true;
      console.log(data);
    },
    submitOrgForm(formName) {
      let self = this;
      var bizUnitName;

      var bizUnitNameOptions = this.bizUnitNameOptions;
      var filterArr = [];
      if (bizUnitNameOptions && bizUnitNameOptions.length > 0) {
        filterArr = bizUnitNameOptions.filter(
          (item) => item.guid == self.ruleForm.bizUnitGuid
        );
      }
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            tenantGuid: self.orgForm.tenantGuid,
            // organisationCode: self.ruleForm.organisationCode,
            organisationName: self.orgForm.organisationName,
            // contactTel: self.ruleForm.contactTel,
            // province: self.ruleForm.province,
            // city: self.ruleForm.city,
            // district: self.ruleForm.district,
            // venue: self.ruleForm.venue,
            // address: self.ruleForm.address,
            bizState: self.orgForm.bizState,
            parentGuid: self.parentGuid,
            orderNum: self.orgForm.orderNum,
            bizUnitGuid: self.orgForm.bizUnitGuid,
            bizUnitName: filterArr.length > 0 && filterArr[0].label,
            updateUnitChild: self.orgForm.updateUnitChild,
            isOperationManageLevel: self.orgForm.isOperationManageLevel,
            isForceManage: self.orgForm.isForceManage,
            isChildForceManage: "Y",
            level: Number(self.orgForm.level),
          };
          self.api
            .postJson(
              `/${serverConfig.msPersonnelService}/organisation/data/add`,
              promise
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dialogFormVisible1 = false;
                self.$message.success("添加组织架构成功");
                self.getSuperiorOrganization(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    upDateOrgForm(formName) {
      let self = this;
      if (self.orgForm.parentGuid == null) {
        self.orgForm.parentGuid = "";
      }
      var bizUnitName;
      var bizUnitNameOptions = this.bizUnitNameOptions;
      var filterArr = [];
      if (bizUnitNameOptions && bizUnitNameOptions.length > 0) {
        filterArr = bizUnitNameOptions.filter(
          (item) => item.guid == self.orgForm.bizUnitGuid
        );
      }
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            guid: self.orgForm.guid,
            tenantGuid: self.page.tenantGuid,
            organisationName: self.orgForm.organisationName,
            bizState: self.orgForm.bizState,
            bizUnitGuid: self.orgForm.bizUnitGuid,
            bizUnitName: filterArr.length > 0 && filterArr[0].label,
            isOperationManageLevel: self.orgForm.isOperationManageLevel,
            updateUnitChild: self.orgForm.updateUnitChild,
            isForceManage: self.orgForm.isForceManage,
            isChildForceManage: "Y",
            parentGuid: self.parentGuid,
            orderNum: self.orgForm.orderNum,
            level: Number(self.orgForm.level),
          };
          self.api
            .put(
              `/${serverConfig.msPersonnelService}/organisation/data/update`,
              promise
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dialogFormVisible1 = false;
                self.$message.success("编辑组织架构成功");
                self.getSuperiorOrganization();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getDeleteDataOrg(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error("请勾选数据！");
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          self.api
            .postJson(
              `/${serverConfig.msPersonnelService}/organisation/data/delete`,
              self.multipleSelection
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success("删除成功");
                self.getSuperiorOrganization();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    resetOpenId(row) {
      let self = this;
      self
        .$confirm("确定清除该人员微信ID吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          self.fullscreenLoading = true;
          self.api
            .put(
              `/${serverConfig.msPersonnelService}/staff/clean/weChatOpenId?guid=${row.guid}`
            )
            .then((res) => {
              self.fullscreenLoading = false;
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success("清除成功");
                self.getData();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          self.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    remove(node, data) {
      this.getDeleteDataOrg(2, data.guid);
      // const parent = node.parent;
      // const children = parent.data.children || parent.data;
      // const index = children.findIndex(d => d.id === data.id);
      // children.splice(index, 1);
    },
    // renderContent(h, { node, data, store }) {
    //   return (
    //     <span class="custom-tree-node">
    //       <span>{node.label}</span>
    //       <span>
    //         <el-button size="mini" type="text" on-click={ () => this.append(data) }>Append</el-button>
    //         <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>Delete</el-button>
    //       </span>
    //     </span>);
    // },

    mouseenter(data) {
      this.$set(data, "show", true);
    },
    mouseleave(data) {
      this.$set(data, "show", false);
    },
  },
};
</script>
<style scoped>
.ipt-sty {
  width: 70% !important;
}
.person-type /deep/.el-radio {
  margin-right: 10px;
}

/* 选项卡 */
.menu-tab {
  width: 25%;
  float: left;
  padding: 15px;
  box-sizing: border-box;
}

.tab-plane {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  /* border-radius: 6px; */
  border: 1px solid #ddd;
}

.tab-plane .tab-list {
  width: 50%;
  line-height: 32px;
  background: rgb(240, 239, 239);
  cursor: pointer;
  /* border-radius: 6px; */
}

.tab-active {
  color: #4fa1a4 !important;
  background: #fff !important;
  border: 1px solid #4fa1a4;
}

.tags-logo {
  width: 16px;
  margin-top: 2px;
  margin-right: 10px;
}

.tags-add {
  width: 17px;
  margin-top: 4px;
  margin-right: 5px;
}

.tags-edit {
  width: 20px;
  margin-top: 0px;
  margin-right: 5px;
}

.tags-del {
  width: 16px;
  margin-top: 2px;
}

.tags-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  /* line-height: 40px; */
  text-align: left;
  padding: 0 10px;
  cursor: pointer;
}

.tags-list-left {
  width: calc(100% - 60px);
  display: flex;
  align-items: center;
}

.tags-list-left span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-list:hover {
  background: rgb(245, 244, 244);
}

.tags-active {
  color: #4fa1a4 !important;
  background: rgb(245, 244, 244);
}

.edit-tags-text {
  padding: 0 80px;
  display: flex;
}

/* 表格 */
.table-tags {
  display: flex;
  justify-content: space-between;
}

.person-tags {
}

.tags-left {
  font-weight: 600;
}

.tags-right {
  cursor: pointer;
  text-decoration: underline;
}

.tags-detail {
  padding: 0 60px;
  text-align: left;
  margin-bottom: 30px;
}

.tags-detail-name {
  display: inline-block;
  width: 120px;
  text-align: right;
  margin-right: 20px;
}

.tags-detail-title {
  font-size: 16px;
  font-weight: 700;
}

.sure-btn {
  width: 50%;
  color: #fff;
  background: #4fa1a4;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 10px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.tab-input {
  width: 100%;
  margin-bottom: 10px;
}

.custom-tree-node {
  display: flex;
  align-items: center;
}

/* .custom-tree-node img {
    width: 18px;
    margin-right: 10px;
  } */
</style>
<style scoped>
.el-col-5 {
  width: 31%;
}

/* 表头设置 */
.setHeadClass .setHead {
  display: flex;
  align-items: flex-start;
  text-align: left;
}

.setHeadClass .setHead p {
  margin: 0;
}

.setHeadClass .setHead .left {
  width: 300px;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  margin-right: 10px;
  height: 556px;
  overflow-y: scroll;
}

.setHeadClass .setHead .right {
  flex: 1;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #ebeef5;
}

.setHeadClass .setHead .right .top {
  text-align: right;
  margin-bottom: 12px;
}
.btnArea span {
  text-decoration: underline;
  color: #4fa1a4;
  margin-left: 12px;
  cursor: pointer;
}
.staff-type {
  display: inline-block;
  width: 72px;
  height: 28px;
  line-height: 28px;
  color: #4fa1a4;
  background: rgba(234, 248, 248, 0.39);
  border-radius: 2px;
}
.staff-type-biz {
  display: inline-block;
  width: 52px;
  height: 28px;
  line-height: 28px;
  color: #4fa1a4;
  background: rgba(234, 248, 248, 0.39);
  border-radius: 2px;
}
.staff-wrap {
  color: #d8814b;
  background: rgba(255, 238, 224, 0.39);
}
.biz-state {
  display: inline-block;
  width: 48px;
  height: 21px;
  line-height: 21px;
  background: rgba(239, 239, 239, 0.38);
  border-radius: 11px;
  margin-left: 5px;
}
.select-node {
  margin: 0 0 17px 0;
  text-align: left;
  font-size: 18px;
  color: #323233;
}
.custom-tree-node {
  display: inline-flex;
  overflow: hidden;
}

.node-lable-sty {
  width: 130px !important;
  text-align: left;
}
</style>
